import './TeamsOverview.scss'

import {Background} from '@codeurs/front'
import placeholder from 'assets/images/placeholder.png'
import React, {useState} from 'react'
import {useHistory} from 'react-router'
import {LinkEntryType} from '../../../campagne/types'
import {ImageType} from '../../../types'
import {useTranslation} from '../../../util/i18n'
import {style} from '../../../util/style'
import {Theme} from '../../Theme'
import {Progressbar} from '../../ui/Progressbar'

const styles = style('teamsoverview', ['item'])

export type TeamsOverviewType = {
	items?: Array<TeamCardType>
	query?: string
}

export type TeamCardType = {
	title: string
	city: string
	value: number
	total: number
	image: ImageType
	url: string
	members: Array<MemberType>
	donationUrl: LinkEntryType
}

type MemberType = {
	firstname: string
	lastname: string
	email: string
}

const INITIALLOADED = 10
const LOADPERTIME = 10

export const TeamsOverview: React.FC<TeamsOverviewType> = ({
	items,
	query = null
}) => {
	const t = useTranslation('teams').card
	const [currentLoaded, setCurrentLoaded] = useState(INITIALLOADED)
	const itemsLength = items?.length
	const hasItems = itemsLength > 0
	const allItemsLoaded = itemsLength <= currentLoaded

	return (
		<div className={styles()}>
			<Theme.Container>
				<div className={styles('items')}>
					{hasItems &&
						items.slice(0, currentLoaded).map((item, i) => (
							<div key={i} className={styles('items-item')}>
								<TeamsOverviewItem item={item} query={query} />
							</div>
						))}
				</div>
				{!allItemsLoaded && (
					<div className={styles('loadmore')}>
						<Theme.Button
							onClick={() => setCurrentLoaded(currentLoaded + LOADPERTIME)}
						>
							{t.load_more}
						</Theme.Button>
					</div>
				)}
			</Theme.Container>
		</div>
	)
}

const TeamsOverviewItem: React.FC<{item: TeamCardType; query: string}> = ({
	item,
	query
}) => {
	const {title, city, value, total, image, url, members, donationUrl} = item
	const t = useTranslation('teams').card
	const history = useHistory()
	const searchedName = getSearchedName(members, query)

	return (
		<div className={styles.item()}>
			<div className={styles.item('top')}>
				<div className={styles.item('top-content')}>
					<Theme.Link to={url}>
						<Theme.H3 mod="green">{title}</Theme.H3>
					</Theme.Link>
					{city && (
						<Theme.H5 className={styles.item('top-content-city')}>
							{t.from} {city}
						</Theme.H5>
					)}
					{searchedName && (
						<Theme.H5 className={styles.item('top-content-city')}>
							{`${t.with} ${searchedName.firstname} ${searchedName.lastname}`}
						</Theme.H5>
					)}
				</div>
				<div className={styles.item('top-image')}>
					<div className={styles.item('top-image-img')}>
						<Theme.Link to={url}>
							<Background
								img={image || placeholder}
								className={styles.item('top-image-img-bg').toString()}
							/>
						</Theme.Link>
					</div>
				</div>
			</div>
			{!isNaN(value) && !isNaN(total) && (
				<div className={styles.item('progressbar')}>
					<Progressbar value={+value} total={+total} />
				</div>
			)}
			<div className={styles.item('bottom')}>
				<Theme.Link to={url} className={styles.item('bottom-link')}>
					{t.to_team_detail}
				</Theme.Link>
				<div className={styles.item('bottom-button')}>
					<Theme.Button
						onClick={() => {
							if (donationUrl) history.push(donationUrl.url)
						}}
						mod={['outline', 'whitebg']}
					>
						{t.support_team}
					</Theme.Button>
				</div>
			</div>
		</div>
	)
}

const getSearchedName = (members: Array<MemberType>, query: string) => {
	if (!members || members.length === 0) return null
	const explodedQuery = query.split(' ')
	const foundMember = members.find((member) => {
		return Object.entries(member).find(([k, field]) => {
			if (k !== 'firstname' && k !== 'lastname') return
			return explodedQuery.find((q) => {
				if (!q || !field) return
				const loweredField = field.toLowerCase()
				const loweredQ = q.toLowerCase()
				return loweredField.includes(loweredQ)
			})
		})
	})
	return foundMember
}
